'use strict';

if (process.env.NODE_ENV === "production") {
  module.exports = require("./emotion.cjs.prod.js");
} else {
  module.exports = require("./emotion.cjs.dev.js");
}



//////////////////
// WEBPACK FOOTER
// ./~/emotion/dist/emotion.cjs.js
// module id = 13
// module chunks = 35783957827783